
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_SET_SIGNATURE = 'AUTH_SET_SIGNATURE'
export const AUTH_SET_WA = 'AUTH_SET_WA'
export const AUTH_PR_REQUEST = 'AUTH_PR_REQUEST' // Password recovery
export const AUTH_PC_REQUEST = 'AUTH_PC_REQUEST' // Password change
export const AUTH_GET_ROLES = 'AUTH_GET_ROLES' // Full system roles list
